module.exports = __webpack_public_path__ + "img/Lime-24-Blog-Banner11.635aa5dc.jpg";